module.exports = __webpack_public_path__ + "img/core-feature-1.395da3f3.png";